import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

/**
 * Contact Confirmation Page
 * Shown after successful contact form submission
 */
const ContactConfirmation = () => {
  return (
    <>
      <Helmet>
        <title>Message Sent - Spawnry</title>
        <meta name="description" content="Thank you for contacting Spawnry. We'll get back to you soon." />
      </Helmet>

      {/* Dark Header */}
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        padding: '100px 0 4rem'
      }}>
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} className="text-center">
              <div style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem'
              }}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <h1 style={{
                color: 'white',
                fontWeight: '700',
                fontSize: 'clamp(1.75rem, 3vw, 2.25rem)',
                marginBottom: '0.75rem'
              }}>
                Message Sent!
              </h1>
              <p style={{
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '1.1rem',
                margin: 0
              }}>
                Thank you for reaching out
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Content Card */}
      <Container style={{ marginTop: '-2rem', paddingBottom: '3rem' }}>
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: '2rem',
              boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
              textAlign: 'center'
            }}>
              <p style={{
                fontSize: '1rem',
                color: '#64748b',
                marginBottom: '1rem',
                lineHeight: '1.6'
              }}>
                We've received your message and will get back to you as soon as possible, typically within 1-2 business days.
              </p>
              <p style={{
                fontSize: '0.95rem',
                color: '#94a3b8',
                marginBottom: '2rem'
              }}>
                A confirmation email has been sent to your inbox.
              </p>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <Link
                  to="/"
                  style={{
                    display: 'block',
                    padding: '0.875rem 1.5rem',
                    fontWeight: '600',
                    fontSize: '1rem',
                    background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                    color: 'white',
                    borderRadius: '10px',
                    textDecoration: 'none',
                    transition: 'transform 0.2s, box-shadow 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 8px 24px rgba(99, 102, 241, 0.4)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  Back to Home
                </Link>
                <Link
                  to="/contact"
                  style={{
                    display: 'block',
                    padding: '0.875rem 1.5rem',
                    fontWeight: '600',
                    fontSize: '1rem',
                    background: 'transparent',
                    color: '#6366f1',
                    borderRadius: '10px',
                    border: '2px solid #e2e8f0',
                    textDecoration: 'none',
                    transition: 'all 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.borderColor = '#6366f1';
                    e.target.style.background = 'rgba(99, 102, 241, 0.02)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.background = 'transparent';
                  }}
                >
                  Send Another Message
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ContactConfirmation;
